
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[username]",
      function () {
        return require("private-next-pages/p/[username]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[username]"])
      });
    }
  